// Result link keys. The results email links to /results/{takeId}#k=r.{takeId}.{mac}; the
// key opens that take's result and rater links on any device. The results page keeps it
// for the session (per take) and strips it from the address bar, so it isn't left in
// history or shared by accident. The hash never reaches the server.

const storageKey = (takeId: string) => `gp_key_${takeId}`;
const memory = new Map<string, string>();

/** The `k=` value in a URL hash, or null. */
export function keyFromHash(hash: string): string | null {
  const k = new URLSearchParams(hash.replace(/^#/, "")).get("k");
  return k && k.length > 0 ? k : null;
}

export function rememberResultKey(takeId: string, key: string): void {
  memory.set(takeId, key);
  try {
    sessionStorage.setItem(storageKey(takeId), key);
  } catch {
    // Private mode or blocked storage: the in-memory copy still works for this visit.
  }
}

/** The key kept for this take, if any. */
export function storedResultKey(takeId: string): string | null {
  try {
    const v = sessionStorage.getItem(storageKey(takeId));
    if (v) return v;
  } catch {
    // Fall through to memory.
  }
  return memory.get(takeId) ?? null;
}

/** For tests. */
export function clearResultKeys(): void {
  memory.clear();
  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }
}

/** Forgets every result key this browser kept (signing out on a shared device). */
export function forgetResultKeys(): void {
  memory.clear();
  try {
    for (const k of Object.keys(sessionStorage)) if (k.startsWith("gp_key_")) sessionStorage.removeItem(k);
  } catch {
    // Nothing kept.
  }
}
